module.exports = __webpack_public_path__ + "img/38.fa060daf.png";